import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/components/fields/confirmation-dialog/confirmation-dialog.component';
import { SystemType } from 'src/app/model/enums/system.type';
import { Helpers } from 'src/app/model/helper/helpers';
import { SearchableItem } from 'src/app/model/interface';
import { PresetValue } from 'src/app/model/preset-value';
import { User } from 'src/app/model/user';
import { ModeService, UserService } from 'src/app/services';
import { IssueType } from '../../models/enums/issue.type';
import { ReportedIssue } from '../../models/reported-issue';
import { HttpService } from '../../services/http-service.service';
declare var $: any;

@Component({
  selector: 'app-report-an-issue-modal',
  templateUrl: './report-an-issue-modal.component.html',
  styleUrls: ['./report-an-issue-modal.component.scss']
})
export class ReportAnIssueModalComponent implements OnInit {
  subscription: any;
  issueTypeValues: SearchableItem[] = [
    PresetValue.create('Report Dangerous Behavior', IssueType.REPORT_DANGEROUS_BEHAVIOR),
    PresetValue.create('Bug Report', IssueType.BUG_REPORT),
    PresetValue.create('Safety Issue', IssueType.SAFETY_ISSUE),
    PresetValue.create('Calculation Mistake', IssueType.CALCULATION_MISTAKE),
    PresetValue.create('Link Doesn’t Work', IssueType.LINK_DOESNT_WORK),
    PresetValue.create('Feature Request', IssueType.FEATURE_REQUEST),
    PresetValue.create('Other Issue', IssueType.OTHER_ISSUE),
  ];
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '8em',
    minHeight: '5em',
    placeholder: 'Start typing here...',
    translate: 'no',
    sanitize: false,
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'subscript',
        'superscript',
        'indent',
        'outdent',
        'insertUnorderedList',
        'insertOrderedList',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };
  files: any[] = [];
  reportedIssue: ReportedIssue = new ReportedIssue();
  loading: boolean = false;

  currentMode: SystemType;
  modeSub: any;
  errMsg: null;
  user: User;
  userSub: any;
  subject: Subject<boolean>;
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private httpService: HttpService,
    private modeService: ModeService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc') {
        this.onCancel();
      }
    });
    this.modeSub = this.modeService.mode$.subscribe(mode => this.currentMode = mode);
    this.userSub = this.userService.user$.subscribe(u => this.user = u);
  }

  ngOnDestroy(): void {
    if (this.modeSub) this.modeSub.unsubscribe();
    if (this.userSub) this.userSub.unsubscribe();
  }
  issueTypeSelected(value: any): void {
    this.reportedIssue.ISSUE_TYPE = value != null ? value.VALUE : null;
  }



  onConfirm(): void { 
    this.loading = true;
    this.reportedIssue.CONTACT_INFO=this.user.EMAIL;
    const formData: FormData = new FormData();
    formData.append('reportedIssue', JSON.stringify(this.reportedIssue));
    if (this.files.length > 0) {
      for (const f of this.files) {
        formData.append('files', f.src);
      }
    }

    this.httpService.reportedIssue(formData, this.currentMode)
      .subscribe(
        data => {
          if (data.success) {
            this.files = [];
            this.bsModalRef.hide();
            this.showSuccessDialog(data.result);
          }
          else {
            this.errMsg = data.error.txt;
            setTimeout(() => {
              this.errMsg = null;
            }, 10000);
          }

          this.loading = false;
        });

  }
  showSuccessDialog(message): void {
    const config = Helpers.getModalConfig();
    config.class = 'modal-dialog-centered';
    this.bsModalRef = this.modalService.show(ConfirmationDialogComponent, config);
    const ackSubject = new Subject<any>();
    this.bsModalRef.content.subject = ackSubject;
    this.bsModalRef.content.title = 'Success';
    this.bsModalRef.content.text = message;
    this.bsModalRef.content.actionButton = 'Ok';
    this.bsModalRef.content.showCancel = false;
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.files = []
  }
  onSelect(event) {
    event.addedFiles.forEach(file => {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        let extension = file.name.substr(file.name.lastIndexOf('.') + 1)
        let obj = { src: event.target.result, thumbnail: '/assets/images/file.png' }
        switch (extension.toLowerCase()) {
          case 'png':
            obj.thumbnail = event.target.result
            break;
          case 'jpg':
          case 'jpeg':
            obj.thumbnail = event.target.result
            break;
          case 'txt':
            obj.thumbnail = '../assets/images/txt.png';
            break;
          case 'csv':
            obj.thumbnail = '../assets/images/csv.png';
            break;
          case 'rtf':
            obj.thumbnail = '../assets/images/rtf.png';
            break;
          case 'pdf':
            obj.thumbnail = '../assets/images/pdf.png';
            break;
          case 'xls':
          case 'xlsx':
            obj.thumbnail = '../assets/images/xls.png';
            break;
          case 'doc':
          case 'docx':
            obj.thumbnail = '../assets/images/doc.png';
            break;
          default:
            break;
        }
        this.files.push(obj);
      };
      reader.readAsDataURL(file);
    });
  }

  onRemove(index) {
    this.files.splice(index, 1)
  }


}
